import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHorizontalBars = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    {...props}
  >
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M80.959 38.622v42.553h56.075c6.715 0 12.158-5.443 12.158-12.158V50.78c0-6.715-5.443-12.158-12.158-12.158zM80.959 105.491v42.553h94.286c6.715 0 12.158-5.443 12.158-12.158v-18.237c0-6.714-5.443-12.158-12.158-12.158zM80.959 172.359v42.553h118.85c6.714 0 12.158-5.443 12.158-12.158v-18.237c0-6.714-5.444-12.158-12.158-12.158z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHorizontalBars;
